// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c110518b","517":"1f94e7ff","659":"c718daaa","701":"68e4df70"}[chunkId] + ".chunk.js";
};